import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import Button from '../../../../Form/Button';
import Modal from '../../../../Modal';
import ModalStore from '../../../../Modal/Store';
import LearningCollectionEditStore from '../../Edit/Store';

export interface Props {
  store: LearningCollectionEditStore;
  modalStore: ModalStore;
}

const BrowseAllWarningModal: React.FC<Props> = ({ store, modalStore }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Are you sure?" />
            </h3>
          }
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <p className="pb-4">
            <T kind="Turning off this setting will remove the full catalog section from your collection." />
          </p>
          <div className="flex justify-end">
            <Button
              type="button"
              value="Cancel"
              className="bg-white text-sm text-teal-600"
              onClick={() => modalStore.close()}
            />
            <Button
              type="button"
              value="Continue"
              className={clsx(
                'ml-4 rounded-md bg-teal-600 py-2.5 px-8 text-sm font-semibold',
                'text-white',
              )}
              onClick={() => {
                store.setBrowseAll(false);
                modalStore.close();
              }}
            />
          </div>
        </Modal>
      );
  }
};

export default observer(BrowseAllWarningModal);
